import Seo from '../components/common/Seo';
import { restaurantSchema } from '../data/business';
import SlowPlateLayout from '../components/slowplate/SlowPlateLayout';
import SpHero from '../components/slowplate/SpHero';
import SpLooks from '../components/slowplate/SpLooks';
import {
  SpCatering,
  SpMenuRail,
  SpSocial,
  SpStory,
  SpTapas,
  SpVisit,
} from '../components/slowplate/SpSections';

const Home = () => {
  return (
    <>
      <Seo
        title="Thai Restaurant in Seattle Near UW | Thaprachan Thai"
        description="Thaprachan Thai Cuisine serves authentic Thai noodles, curries, street food and desserts at 805 NE 65th St in north Seattle, minutes from UW."
        path="/"
        ogType="restaurant.restaurant"
        schemas={[restaurantSchema]}
      />

      <SlowPlateLayout>
        <SpHero />
        <SpLooks />
        <SpMenuRail />
        <SpStory />
        <SpTapas />
        <SpVisit />
        <SpCatering />
        <SpSocial />
      </SlowPlateLayout>
    </>
  );
};

export default Home;
